export enum Orientation {
    Vertical = "column",
    Horizontal = "row"
}
